import React from 'react'
import { Button } from 'components/button'
import './style.scss'

export function ProductActivation({ activationInfo = {} }) {
  const { itemName: name, description, imageUrl: banner, urlDocument } = activationInfo.product

  function handleActivateClick() {
    const { activationLink } = activationInfo

    window.open(activationLink)
  }

  function handleOpenManualClick() {
    window.open(urlDocument)
  }

  function renderManualPdf() {
    if (!urlDocument) return null

    return (
      <Button onClick={handleOpenManualClick} color='primary' className='button manual'>
        Manual de ativação
      </Button>
    )
  }

  return (
    <div className='container-activation'>
      <div className='container-banner'>
        <img alt={`Banner do produto ${name}`} className='image' src={banner} />
      </div>
      <div className='container-info'>
        <span className='title'>{name}</span>
        <span className='description'>{description}</span>
      </div>
      <div className='container-buttons'>
        <Button onClick={handleActivateClick} color='primary' className='button activate'>
          Ativar assinatura
        </Button>
        {renderManualPdf()}
      </div>
    </div>
  )
}
